<template>
  <div>
    <div class="cart-container">
      <div
        v-if="count >= 1"
        class="cart"
      >
        <p class="cart__heading">
          {{ 'Yhteensä ' + count + (count == 1 ? ' tuote' : ' tuotetta') }}
        </p>

        <div class="cart__items-heading">
          <span class="cart__column cart__column--heading cart__column--heading--product cart__column--product cart__column--product--offer">Tuote</span>
          <span class="cart__column cart__column--heading cart__column--price">Kust.hinta</span>
          <span class="cart__column cart__column--heading cart__column--price">Hinta / kpl</span>
          <span class="cart__column cart__column--heading cart__column--profit">Kate</span>
          <span class="cart__column cart__column--heading cart__column--amount">Määrä</span>
          <span class="cart__column cart__column--heading cart__column--sum">Yhteensä</span>
        </div>
        <Container
          drag-handle-selector=".js-handle"
          drag-class="state-dragging"
          role="list"
          @drop="onDrop"
        >
          <Draggable
            v-for="(cart_item, index) in cartContents"
            :key="cart_item.key"
            class="cart__line-item-container"
          >
            <CartItem
              :ref="'cart-item-' + cart_item.key"
              :key="cart_item.key"
              :original-cart-item="cart_item"
              order-type="offer"
              :is-last-item="cartContents.length === (parseInt(index) + 1)"
              :is-first-item="index === 0"
              @remove="removeItem(cart_item)"
              @update="updateCartItem(cart_item, $event)"
              @moveUp="moveUp(cart_item)"
              @moveDown="moveDown(cart_item)"
              @editCartItem="editCartItem(cart_item)"
              @duplicate="duplicateCartItem($event)"
            />
          </Draggable>
        </Container>
      </div>
      <div
        v-if="count === 0"
        class="cart__empty-container empty-cart"
      >
        <p class="empty-cart__text">
          Ei tuotteita
        </p>
      </div>
    </div>

    <CartModal
      ref="cartmodal"
      :display="displayModal"
      :default-product="selectedProduct"
      :nonce="nonce"
      @confirm="saveProductFromModal"
      @cancel="closeModal"
      @remove="handleModalItemRemove"
    />
    <div
      v-if="$store.getters.changesAllowed"
      class="cart-footer cart-footer--search"
    >
      <cart-product-search :nonce="nonce" />
    </div>
  </div>
</template>

<script>
import CartItem from '../../components/cart/cart-item.vue';
import CartModal from '../../components/cart/cart-modal.vue';
import CartProductSearch from '../../components/cart/cart-product-search.vue';
import axios from 'axios';
import { Container, Draggable } from "vue-smooth-dnd";
import { EventBus } from '../../event-bus';
import _ from 'lodash';

export default {
    components: {
        CartItem,
        CartModal,
        Container,
        Draggable,
        CartProductSearch,
    },
    props: {
        defaultCartContents: {
            type: Array,
            default: function(){
                return [];
            },
        },
        nonce: {
            type: String,
            default: '',
        },
        isChangesAllowed: Boolean,
    },

    data : function () {
        return {
            displayModal: false,
            selectedProduct: null,
        }
    },

    computed: {
        cartContents() {
            return this.$store.getters.getCartContents;
        },

        count() {
            return this.$store.getters.getTotals.count;
        },
    },

    mounted: function() {
        this.$store.commit('setCartContents', this.defaultCartContents);
        this.$store.commit('setChangesAllowed', this.isChangesAllowed);
    },

    methods: {

        duplicateCartItem( cartItem ) {
            //Add to Cart
            let request = _.cloneDeep( cartItem );

            const originalIndex = _.findIndex( this.cartContents, [
                'key',
                cartItem.key,
            ] );

            if ( cartItem.custom_image_id ) {
                request.custom_image = cartItem.custom_image_id;
            }

            delete request.cart_item_key;
            delete request.cart_order;

            let config = {
                headers: {
                    'X-WP-Nonce': this.nonce,
                },
            };

            this.$store.commit( 'startToLoadNewItem', parseInt( originalIndex, 10 ) + 1 );

            axios.post( '/wp-json/modeo/v2/cart/add_to_cart', request, config )
                 .then( response => {
                     if ( response.data.status === true ) {

                         const newCartContents = response.data.cart_contents;
                         const newIndex = parseInt( originalIndex, 10 ) + 1;

                         let index = _.findLastKey( newCartContents );
                         let cartContents = _.clone( newCartContents );
                         let removedItem = cartContents.splice( index, 1 );
                         cartContents.splice( newIndex, 0, removedItem[ 0 ] );

                         for ( let i = 0; i < cartContents.length; i++ ) {
                             cartContents[ i ].cart_order = i;
                         }

                         let totals = {
                             subtotal: response.data.subtotal,
                             subtotalTax: response.data.subtotal_tax,
                             total: response.data.total,
                             discount: response.data.discount_total,
                             discountTax: response.data.discount_tax,
                             count: response.data.cart_product_count,
                         };

                         this.$store.commit( 'setTotals', totals );

                         this.$store.commit( 'setCartContents', cartContents );
                         this.saveCartOrder();

                         this.updateCartItem( cartContents[ newIndex ], {
                             'quantity': parseInt( cartContents[ newIndex ].quantity ),
                             'estimated_delivery_time_with_add_ons': response.data.delivery_time,
                             'cost_price': cartContents[ newIndex ].cost_price,
                             'price': cartContents[ newIndex ].price,
                         } );
                     } else {
                         let messages = '';
                         if ( typeof response.data.status_messages !== 'undefined' && response.data.status_messages.length > 0 ) {
                             messages = ': ' + response.data.status_messages.join( "\n" );
                         }

                         let productAddedToCartData = {
                             message: this.$modeoL10n.add_to_offer_failed + messages,
                             notificationType: 'single-message',
                         };
                         EventBus.$emit( 'notify', productAddedToCartData );
                     }
                 } ).catch(() => {
                    let newCartContents = _.clone(this.cartContents);
                    newCartContents.splice(parseInt( originalIndex, 10 ) + 1, 1);
                    this.$store.commit('setCartContents', newCartContents);

                    EventBus.$emit("notify", {
                        message: 'Tuotteen kopiointi epäonnistui.',
                        notificationType: "single-message",
                    });
            });
        },

        updateCartItem(cartItem, data) {
            let index = this.findCartItemIndexByKey(cartItem.key);
            let cartContents = _.clone(this.cartContents);
            cartContents[index].quantity = data.quantity;
            cartContents[index].cost_price = data.cost_price;
            cartContents[index].price = data.price;
            this.$store.commit('setCartContents', cartContents);
        },

        findCartItemIndexByKey(key) {
            for (let i=0; i < this.cartContents.length; i++) {
                if (this.cartContents[i].key === key) {
                    return i;
                }
            }
        },

        onDrop(dropResult) {
            let cartContents = _.clone(this.cartContents);
            let removedItem = cartContents.splice(dropResult.removedIndex, 1);
            cartContents.splice(dropResult.addedIndex, 0, removedItem[0]);
            cartContents = this.updateCartOrders(cartContents);

            this.$store.commit('setCartContents', cartContents);
            this.saveCartOrder();
        },

        moveDown(cartItem) {
            let index = this.findCartItemIndexByKey(cartItem.key);
            let cartContents = _.clone(this.cartContents);
            let removedItem = cartContents.splice(index, 1);
            cartContents.splice(index + 1, 0, removedItem[0]);
            cartContents = this.updateCartOrders(cartContents);

            this.$store.commit('setCartContents', cartContents);
            this.saveCartOrder();
        },

        moveUp(cartItem) {
            let index = this.findCartItemIndexByKey(cartItem.key);
            let cartContents = _.clone(this.cartContents);
            let removedItem = cartContents.splice(index, 1);
            cartContents.splice(index - 1, 0, removedItem[0]);
            cartContents = this.updateCartOrders(cartContents);

            this.$store.commit('setCartContents', cartContents);
            this.saveCartOrder();
        },

        updateCartOrders(cartContents) {
            for (let i = 0; i < cartContents.length; i++) {
                cartContents[i].cart_order = i;
            }
            return cartContents;
        },

        closeModal() {
            this.displayModal = false;
        },

        editCartItem(cartItem) {
            this.selectedProduct = _.clone(cartItem);
            this.displayModal = true;
        },

        saveProductFromModal(data) {
            let newCartContents = _.clone(this.cartContents);

            _.remove(newCartContents, function(item) {
                return item.key === data.oldKey;
            });

            newCartContents.push(data.cartItem);

            newCartContents.sort( function(a, b) {
                let aOrder = a.cart_order === '' ? 0 : a.cart_order;
                let bOrder = b.cart_order === '' ? 0 : b.cart_order;
                return parseInt(aOrder) - parseInt(bOrder);
            });

            this.$store.commit('setCartContents', newCartContents);
            this.closeModal();
        },

        saveCartOrder() {
            let request = {
                "cart_contents": this.cartContents,
            };

            let config = {
                headers: {
                    'X-WP-Nonce': this.cartContents[0].nonce,
                },
            }

            //Save to CartOrder to VueX
            axios.post('/wp-json/modeo/v2/cart/save_cart_order', request, config)
            .catch((error) => {
                if ( error.response ) {

                    if ( error.response.status === 403 && error.response.data.code === 'Forbidden' ) {
                        let productAddedToCartData = {
                            message: this.$modeoL10n.offer_modification_failed,
                            notificationType: 'single-message',
                        };
                        EventBus.$emit( 'notify', productAddedToCartData );
                    }

                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log( error.response.data );
                    console.log( error.response.status );
                    console.log( error.response.headers );
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log( 'Error', error.message );
                }
                console.log( error.config );
            });

        },

        handleModalItemRemove(cartItem) {
            this.removeItem(cartItem);
            this.closeModal();
        },

        removeItem(cartItem) {

            let request = {
                "cart_item_key": cartItem.key,
                "add_ons": cartItem.add_ons,
                "quantity": 0,
            };

            let config = {
                headers: {
                    'X-WP-Nonce': cartItem.nonce,
                },
            };

            axios.post('/wp-json/modeo/v2/cart/update_cart_item', request, config)
            .then(response => {

                let totals = {
                    subtotal: response.data.subtotal,
                    subtotalTax: response.data.subtotal_tax,
                    total: response.data.total,
                    discount: response.data.discount_total,
                    discountTax: response.data.discount_tax,
                    count: response.data.cart_product_count,
                };

                this.$store.commit('setTotals', totals);

                let newCartContents = _.clone(this.cartContents);

                _.remove(newCartContents, function(item) {
                    return item.key === cartItem.key;
                });

                this.$store.commit('setCartContents', newCartContents);
            })
            .catch((error) => {
                if ( error.response ) {

                    if ( error.response.status === 403 && error.response.data.code === 'Forbidden' ) {
                        let productAddedToCartData = {
                            message: this.$modeoL10n.offer_modification_failed,
                            notificationType: 'single-message',
                        };
                        EventBus.$emit( 'notify', productAddedToCartData );
                    }

                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log( error.response.data );
                    console.log( error.response.status );
                    console.log( error.response.headers );
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log( 'Error', error.message );
                }
                console.log( error.config );
            });

        },
    },
}
</script>
